// MySQL organization.orgtype values
export const ORG_TYPE_MHN_ACO = 'MHN ACO';
export const ORG_TYPE_ACO_REACH = 'ACO REACH';
export const ORG_TYPE_MSSP = 'MSSP';

// MySQL organization.orgsubtype values
export const ORG_SUBTYPE_COUNTYCARE = 'CountyCare';
export const ORG_SUBTYPE_AETNA = 'Aetna';
export const ORG_SUBTYPE_IL = 'IL';

// MySQL organization.orgname values
export const ORG_NAME_MHN_ACO_LEGACY = 'MHN ACO';
export const ORG_NAME_MHN_ACO_CC_WW = 'MHN ACO CC/WW';
export const ORG_NAME_MHN_ACO_AETNA = 'MHN ACO Aetna';
export const ORG_NAME_ACO_REACH_IL = 'ACO REACH IL';
